export default __webpack_public_path__ + "static/media/NovelZone.a196fd91.png";